/**
 * form-response-autohide.js
 * Fades out and hides any [data-autohide] form response message
 * (success or error) after 3 seconds.
 *
 * Used by: newsletter.liquid, membership-form.liquid
 */
(function () {
  var DELAY_MS    = 3000;
  var FADE_MS     = 600;

  document.querySelectorAll('[data-autohide]').forEach(function (msg) {
    msg.style.transition = 'opacity ' + (FADE_MS / 1000) + 's ease';

    setTimeout(function () {
      msg.style.opacity = '0';
      setTimeout(function () {
        msg.style.display = 'none';
      }, FADE_MS);
    }, DELAY_MS);
  });
})();
